PRC.equalizeHeaders = function(){
	$('.featured-grid--root--prc').each(function(){
		var tallest_height = 0;
		$(this).find('.featured-grid--item--title').css('min-height', '');
		$(this).find('.featured-grid--item--title').each(function(){
			if($(this).height() > tallest_height){
				tallest_height = $(this).height();
			}
		});
		// console.log($(this), tallest_height);
		$(this).find('.featured-grid--item--title').css('min-height', tallest_height);
	});
};

$(document).ready(function(){
	if($(window).width() >= 768){
		PRC.equalizeHeaders();
	}
});

$(window).resize(function(){
	if($(window).width() >= 768){
		PRC.equalizeHeaders();
	}
});
